module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("erXMK"))).then(() => module.bundle.root('5erN3'));